export const typesCruisedet = {
    GET_CRUISEDET_SUCCESS:'GET_CRUISEDET_SUCCESS',
    GET_CRUISEDET_ERROR:'GET_CRUISEDET_ERROR',
    GET_CRUISEDET_BEGIN:'GET_CRUISEDET_BEGIN'
}
